// Simple logger implementation for server-side services
export const logger = {
  info: (message: string, ...args: unknown[]) => {
    console.log(`[${new Date().toISOString()}] INFO: ${message}`, ...args);
  },

  error: (message: string, error?: unknown, ...args: unknown[]) => {
    console.error(
      `[${new Date().toISOString()}] ERROR: ${message}`,
      error,
      ...args,
    );
  },

  warn: (message: string, ...args: unknown[]) => {
    console.warn(`[${new Date().toISOString()}] WARN: ${message}`, ...args);
  },

  debug: (message: string, ...args: unknown[]) => {
    if (process.env.DEBUG) {
      console.log(`[${new Date().toISOString()}] DEBUG: ${message}`, ...args);
    }
  },
};
